import {Modal, Popover} from 'bootstrap';
import {doAjax} from "../common/_ajax";
import remainingChars from "surveylabJsAssets/page/_remaining-chars";
import {isTouchDevice} from "surveylabJsAssets/common/_globals";
import _slider from "surveylabJsAssets/page/_slider";

export default function () {
    $(function () {
        const $commentBtn = $('.comment-button');
        const $modal = $('#comment-modal');
        const $isSending = $('#modal-spinner', $modal);
        const modal = new Modal(document.getElementById('comment-modal'));

        // hide loadinganimation on load
        $isSending.hide();
        const popover = Popover.getInstance($commentBtn.get(0));
        if (isTouchDevice()) {
            // never show the comment button popover on touch devices
            popover.dispose();
        }
        $commentBtn.on('mousedown', function () {
            if (popover) {
                popover.hide();
            }
        }).on('click', function () {
            modal.show();
        });

        $modal.on('hidden.bs.modal', function () {
            $('textarea', '#comment-form').val('');
            $('#remaining-char-comment').addClass('hidden');
            $('.form-group', '#comment-form').removeClass('has-error');
            $('.alert-validation', '#comment-form').parent().hide();
            $isSending.hide();
        }).on('shown.bs.modal', function () {
            _slider.updateStickyTableHeaders(); // Handle sticky headers because page is scrolling up when modal is shown
        });
        $('.comment-send-btn', $modal).on('click', function () {
            $isSending.show();
            const comment = {
                'comment': $('textarea', '#comment-form').val(),
                'pageID': $("input[name='hidden-page-id']").val(),
                'userSurveyID': $("input[name='hidden-user-survey-id']").val()
            };
            const commentUrl = $('#comment-save-url').val();
            const jqXHR = doAjax({url: commentUrl, data: comment});
            jqXHR.done(function () {
                modal.hide();
            });
            jqXHR.always(function () {
                $isSending.hide();
            });
        });
    });
    remainingChars.initOnce();
}